import { AuthProvider } from '@/context/AuthContext.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { APIProvider } from '@vis.gl/react-google-maps';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import i18n from 'i18next';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import translations from './locale/translations.ts';
import router from './router/router.tsx';
// import * as Sentry from '@sentry/react';
import { ThemeProvider } from '@/context/ThemeContext.tsx';
import '@fontsource-variable/inter';
import '@fontsource/work-sans/700-italic.css';
import '@fontsource/plus-jakarta-sans/300.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import 'react-day-picker/src/style.css';
import { Toaster } from 'sonner';
import './styles/jakartaLegacy.css';
import './index.css';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
  ],
  sendDefaultPii: true,
  tracesSampleRate: 0.1,
});
dayjs.extend(utc);

i18n.use(initReactI18next).init({
  resources: translations,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <APIProvider apiKey={import.meta.env.VITE_GOOGLE_PLACES_API_KEY ?? ''} libraries={['marker', 'places']}>
        <ThemeProvider>
          <AuthProvider>
            <Toaster position="top-center" richColors />
            <RouterProvider router={router} />
          </AuthProvider>
        </ThemeProvider>
      </APIProvider>
    </QueryClientProvider>
  </StrictMode>
);
